import React from "react";

/**
 * Brand mark: speech bubble containing the numeral 1, supported by three short
 * blue / red / yellow signal lines. Pure SVG, single scalable asset.
 */
export function Logo({ size = 34, className = "", withSignals = true }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      role="img"
      aria-label="Satu Soalan"
      className={className}
    >
      <path
        d="M11 5h26a6 6 0 0 1 6 6v18a6 6 0 0 1-6 6H26l-9.6 7.3A1.2 1.2 0 0 1 14.5 41.4V35h-3.5a6 6 0 0 1-6-6V11a6 6 0 0 1 6-6Z"
        fill="hsl(var(--ss-panel))"
      />
      <path
        d="M22.6 29.4V16.2l-3.9 2.3-1.5-3 6.1-3.6h3.4v17.5h-4.1Z"
        fill="hsl(var(--ss-accent))"
      />
      {withSignals && (
        <g strokeWidth="2.6" strokeLinecap="round">
          <path d="M31 40.5h9" stroke="hsl(var(--ss-accent))" />
          <path d="M33.5 44.5h6.5" stroke="hsl(var(--ss-accent))" />
          <path d="M36.5 36.5h3.5" stroke="hsl(var(--ss-accent2))" />
        </g>
      )}
    </svg>
  );
}

export function LogoWordmark({ className = "", compact = false, inverted = false }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <Logo size={compact ? 28 : 34} />
      <span className="flex flex-col leading-none">
        <span
          className={`text-[15px] font-extrabold tracking-[-0.02em] ${
            inverted ? "text-white" : "text-foreground"
          }`}
        >
          Satu Soalan
        </span>
        {!compact && (
          <span
            className={`mt-0.5 text-[10px] font-bold uppercase tracking-[0.18em] ${
              inverted ? "text-white/60" : "text-[hsl(var(--muted-foreground))]"
            }`}
          >
            untuk PMX
          </span>
        )}
      </span>
    </span>
  );
}

/** Abstract conversation composition used in the hero. No flags, no photos. */
export function SpeechBubbleArt({ className = "" }) {
  return (
    <svg viewBox="0 0 340 230" className={className} aria-hidden="true">
      <rect x="16" y="20" width="208" height="104" rx="26" fill="hsl(var(--ss-accent))" opacity="0.07" />
      <rect
        x="104"
        y="104"
        width="210"
        height="96"
        rx="26"
        fill="none"
        stroke="hsl(var(--ss-panel))"
        strokeOpacity="0.14"
        strokeWidth="2"
      />
      <circle cx="268" cy="58" r="32" fill="hsl(var(--ss-accent))" opacity="0.16" />
      <g strokeWidth="6" strokeLinecap="round">
        <path d="M44 154h96" stroke="hsl(var(--ss-accent))" strokeOpacity="0.2" />
        <path d="M44 172h58" stroke="hsl(var(--ss-accent))" strokeOpacity="0.18" />
        <path d="M44 190h30" stroke="hsl(var(--ss-accent2))" strokeOpacity="0.5" />
      </g>
    </svg>
  );
}

export function SignalLines({ className = "" }) {
  return (
    <span className={`inline-flex items-center gap-1.5 ${className}`} aria-hidden="true">
      <span className="h-1 w-6 rounded-full bg-[hsl(var(--ss-accent))]" />
      <span className="h-1 w-4 rounded-full bg-[hsl(var(--ss-accent))]" />
      <span className="h-1 w-2.5 rounded-full bg-[hsl(var(--ss-accent2))]" />
    </span>
  );
}
